import { useMemo } from 'react';
import { useIsMobile } from '@shared/hooks/useBreakpoint';

export interface SuperSidebarViewModel {
  isMobile: boolean;
  resolveActive: (to: string, activePath: string) => boolean;
}

export function useSuperSidebar(): SuperSidebarViewModel {
  const isMobile = useIsMobile();
  return useMemo<SuperSidebarViewModel>(
    () => ({
      isMobile,
      resolveActive: (to, activePath) => activePath === to || activePath.startsWith(`${to}/`),
    }),
    [isMobile],
  );
}
